const brandingConfig = {
    'kingpin.multicomputos.com': {
      logoExpanded: '/multicomputos_logo.png',
      logoCollapsed: '/multi_ti.png',
    },
    'kingpin.thefinlabs.com': {
      logoExpanded: '/finlabs.webp',
      logoCollapsed: '/finlabs_f.png',
    },
    'default': {
      logoExpanded: '/mindcoretr.png',
      logoCollapsed: '/mc_bullet.png',
    }
  };
  
  export default brandingConfig;